<template>
  <div>
    <el-container>
      <el-header>
        <div style="margin: 10px 0">
          <el-input v-model="serchat" placeholder="请输入客户名称" maxlength="30" style="width: 150px;"></el-input>
          <el-date-picker
            v-model="time"
            type="daterange"
            value-format="timestamp"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
          <el-dropdown split-button type="primary" @command="commandEvent">
            <span v-html="dropdownTitle"></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="全部">全部</el-dropdown-item>
              <el-dropdown-item v-for="(item,index) in dropdownList" :key="index" :command="item.label">{{item.label}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="isAjax" plain>查询</el-button>
        </div>
      </el-header>
      <el-main v-loading.fullscreen.lock="fullscreenLoading">
        <template>
          <el-table
            :data="tableData"
            stripe
            :height="divHeight"
            style="width: 100%">
            <el-table-column
              prop="customerName"
              label="名称"
              width="250">
            </el-table-column>
            <!--<el-table-column
              prop="class"
              label="客户分类"
              width="280">
            </el-table-column>-->
            <el-table-column type="expand" label="展开详情" width="180">
              <template slot-scope="props">
                <el-table
                  :data="props.row.productList"
                  border
                  size="small"
                  style="width: 100%">
                  <el-table-column
                    prop="productName"
                    label="商品名称"
                    width="180">
                  </el-table-column>
                  <el-table-column
                    prop="number"
                    label="商品销量"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    prop="productDeal"
                    label="商品销售额"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    prop="productStandards"
                    label="商品规格"
                    width="100">
                    <template slot-scope="scope">
                      <span>{{ scope.row.spk_productStandards ? scope.row.scope.spk_productStandards : scope.row.scope.productStandards }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="productPzwh"
                    label="商品批准文号"
                    width="170">
                  </el-table-column>
                  <el-table-column
                    prop="productFactory"
                    label="商品厂家"
                    width="180">
                  </el-table-column>
                  <el-table-column
                    prop="brand"
                    label="品牌"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    prop="unit"
                    label="单位"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    prop="isPrescription"
                    label="是否处方药"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="breed"
                    label="经营品种"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="dosageForm"
                    label="剂型"
                    width="100">
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column
              prop="productCount"
              label="统计数量"
              width="180">
            </el-table-column>
            <el-table-column
              prop="identification"
              label="标识"
              width="180">
            </el-table-column>
            <el-table-column
              prop="dataTime"
              label="统计时间"
              width="250">
            </el-table-column>
          </el-table>
        </template>
      </el-main>
      <el-footer>
        <el-pagination
          background
          @size-change="handleSizeChange0"
          @current-change="handleCurrentChange0"
          :current-page="currentPage0"
          :page-sizes="[30, 40, 50]"
          :page-size="count0"
          layout="total, sizes, prev, pager, next, jumper"
          :total="allcount0">
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        serchat:"",
        fullscreenLoading: false,
        time:"",
        dropdownTitle:"请选择",
        tableData:[],
        allcount0:0,//总页数 对应 total
        count0:30,//一页显示多少量 对应 page-size
        currentPage0:1,//当前页数
        divHeight:500,
        dropdownList:[]
      }
    },
    methods:{
      formatTime:function(row, column) {
        var date = new Date(row[column.property]);
        var format = "yyyy年MM月dd日";
        var o = {
          "M+" : date.getMonth()+1, //month
          "d+" : date.getDate(),    //day
          "h+" : date.getHours(),   //hour
          "m+" : date.getMinutes(), //minute
          "s+" : date.getSeconds(), //second
          "q+" : Math.floor((date.getMonth()+3)/3),  //quarter
          "S" : date.getMilliseconds() //millisecond
        };
        if(/(y+)/.test(format)) format=format.replace(RegExp.$1,
          (date.getFullYear()+"").substr(4 - RegExp.$1.length));
        for(var k in o)if(new RegExp("("+ k +")").test(format))
          format = format.replace(RegExp.$1,
            RegExp.$1.length==1 ? o[k] :
              ("00"+ o[k]).substr((""+ o[k]).length));
        return format;
      },
      commandEvent(command) {
        this.dropdownTitle = command
      },
      handleSizeChange0(val) {
        this.count0 = val;
        this.isAjax();
      },
      handleCurrentChange0(val) {
        this.currentPage0 = val;
        this.isAjax();
      },
      addClass:async function(){
        await this.$axios.post('/data/addClass',{
          uid:""
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.dropdownList = response.data[0];
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      isAjax:async function(){
        const h = this.$createElement;
        this.$notify({
          title: '提示',
          message: h('i', { style: 'color: red'}, '该功能目前只兼容部分2.5.9版本。')
        });
        this.fullscreenLoading = true;
        await this.$axios.post('/data/addDayProductData',{
          d:this.dropdownTitle,
          s:this.serchat,
          t:this.time,
          "count":this.count0,
          "page":this.currentPage0
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.tableData = response.data[0];
            this.allcount0 = response.data[1];
            this.divHeight = window.innerHeight-158;
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
          this.fullscreenLoading = false;
        }).catch(function (error) {
          this.$message.error(error);
          this.fullscreenLoading = false;
        });
      }
    },
    mounted(){
      this.addClass();
      this.isAjax();
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/dataStatistics/productData.vue